import { Component, OnInit, ViewChild } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';
import { InputSwitch } from 'primeng/inputswitch';
import { ConfirmationService,MessageService } from "primeng/api";
import { BreadcrumbService } from 'app/breadcrumb.service';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { IUser } from 'app/shared/Domains/IUser';
import * as _ from 'lodash';
import { Employee } from 'app/Employees/domain/employee';
import { LanguageService } from 'app/LanguageService/Language.Service';

@Component({
  selector: 'app-employee-salary-management',
  templateUrl: './employee-salary-management.component.html',
  styleUrls: ['./employee-salary-management.component.css']
})
export class EmployeeSalaryManagementComponent implements OnInit {
  allDesignationDd: any[];
  allDesignation: IDesignationManagement[];
  designationManagement: IDesignationManagement;
  mode: string = 'add';
  enterSteps: any[];
  isConfirmationBox: boolean;
  currentStep: any;
  currencyDropDown: any[] = [];
  user: any;
  role: any;
  users: any[];
  sourceUsers: any[];
  loading: boolean = false;
  imgPreview: boolean = false;
  imgPreviewImg: any;
  userObj: IUser;
  first: number = 0;
  employee: Employee;

  constructor(
    private LanguageService: LanguageService,
    private confirmationService: ConfirmationService,
    private breadcrumbService: BreadcrumbService,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService
  ) { }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("EmployeeSalaryManagementComponent", label);
  }
  ngOnInit(): void {
    this.userObj = new IUser();
    this.role = AuthService.getLoggedInRole();
    this.designationManagement = new IDesignationManagement();

    this.isConfirmationBox = false;

    this.user = AuthService.getLoggedInUser();
    this.users = [];
    this.sourceUsers = [];

    this.employee = new Employee();


    this.breadcrumbService.setItems([
      { label: "HR Management" },
      { label: "Employee Salary Management" },
    ]);
    this.userObj.company = AuthService.getLoggedInCompany();
    this.userObj.branch = AuthService.getLoggedInBranch();

    this.getAllDesignation();
    this.getEmployees();
    // this.getAllUsers();
  }

  getAllDesignation(){
    this.appServiceManager.get(`hr/getAllDesignation/company/${this.user.company}/branch/${this.user.branch}`).subscribe((res: any) => {
      if (res.length > 0) {
        this.allDesignation = res;
        this.allDesignationDd = this.createDdOptions(res, 'Select designation');
        // console.log("this.allDesignation",this.createDdOptions(res, 'Select designation'));

      } else {
        this.allDesignation = [];
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  // getAllUsers(){
  //   this.loading = true;
  //   this.appServiceManager.post('users/search', this.userObj).subscribe((res: any) => {
  //     if (res.length > 0) {
  //       this.users = res.filter((value: { userRole: any; }) => value.userRole.name !== "Super Admin");
  //       // console.log("this.users = res;",res);
  //     } else {
  //       this.messageService.clear();
  //       this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
  //     }
  //   },
  //     (error) => {
  //       this.loading = false;
  //       this.messageService.clear();
  //       this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
  //     });
  // }

  getEmployees() {
    this.loading = true;
    this.appServiceManager.get(`employees/company/${this.user.company}/branch/${this.user.branch}/getAllEmployees`).subscribe((res: any) => {
      if (res.length > 0) {
        this.users = res;
        this.sourceUsers = res;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  searchLocal(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.users = Object.assign([], this.sourceUsers);
      }
      if (!value) {
        this.users = Object.assign([], this.sourceUsers);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceUsers).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.users = source.filter(distinct);

        if (this.users.length === 0) {
          this.users = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.users.length === 1) {
            this.first = 0;
          }
          this.users = [...this.users];
        }
      }
    } else {
      this.users = Object.assign([], this.sourceUsers);
      this.users = [...this.users];
    }
  }

  clear() {
    this.employee = new Employee();
    this.searchLocal("", "");
    this.first = 0;
  }

  createDdOptions(ValueDetails: any[], name: string) {
    var itemsDd = [];
    var FirstOption = { label: name, value: 0 };
    itemsDd.push(FirstOption);
    ValueDetails.forEach(element => {
      var item = { label: element.name, value: element._id };
      itemsDd.push(item);
    });
    return itemsDd;
  }

  openPhoto(imgUri){
    this.imgPreview = true;
    this.imgPreviewImg = imgUri;
  }

  closePhotoPreview(){
    this.imgPreview = false;
    this.imgPreviewImg = "";
  }

  onPageChange(event) {
    this.first = event.first;
  }

  updateUserPackages(){
    this.isConfirmationBox = true;
    this.confirmationService.confirm({
      message: "Are you sure you want to update Employee's Salary?",
      accept: () => {
        this.loading = true;
        let data = {
          company:this.userObj.company,
          branch:this.userObj.branch,
          allUsers:this.users,
        }
        this.appServiceManager.put('hr/UpdateUserDesignation', data).subscribe((res: any) => {
          if (res.length > 0) {
            // this.users = res.filter((value: { userRole: any; }) => value.userRole.name !== "Super Admin");
            // console.log("this.users = res;",res);
            this.messageService.clear();
            this.messageService.add({
                severity: "success",
                summary: "Success Message",
                detail: "Users Successfully Updated",
            });
            // this.getAllUsers();
            this.getEmployees();
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
          }
        },
        (error) => {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
      },
      reject: () => {}
    });
  }
}

class IDesignationManagement {
  name              : String;
  isActive          : Boolean;
  currency          : String;
  salary            : Number;
  branch            : String;
  company           : String;
  isDelete          : Boolean;
  createdBy         : String;
  createdDate       : Date;
  modifiedBy        : String;
  modifiedDate      : Date;
}
